import { SnackbarType, ProblemDetail } from '@core/models';
import { ToastrType } from '@core/models/ui/toastr-config';

export class OpenMenuAction {
  static readonly type = '[Ui] Open Menu';
}

export class CloseMenuAction {
  static readonly type = '[Ui] Close Menu';
}
export class EnableMobileModeAction {
  static readonly type = '[Ui] Enable Mobile Mode';
}

export class DisableMobileModeAction {
  static readonly type = '[Ui] Disable Mobile Mode';
}

export class OpenSnackbarAction {
  static readonly type = '[Ui] Open Snackbar';

  constructor(public payload: { type: SnackbarType, message?: string; problemDetail?: ProblemDetail }) { }
}

export class OpenToastrAction {
  static readonly type = '[Ui] Open Toaster';

  constructor(public payload: { type: ToastrType, message?: string; problemDetail?: ProblemDetail , title:string}) { }
}

export class CloseToastrAction {
  static readonly type = '[Ui] Close Toaster';
}

export class CloseSnackbarAction {
  static readonly type = '[Ui] Close Snackbar';
}

export class ShowSpinnerAction {
  static readonly type = '[Ui] Show Spinner';
}

export class HideSpinnerAction {
  static readonly type = '[Ui] Hide Spinner';
}

export class SetThemeAction {
  static readonly type = '[Ui] Set Theme';

  constructor(public payload: { theme: string; }) { }
}

export class ToggleIsInferiorBrowserAction {
  static readonly type = '[Ui] Toggle Is Inferior Browser Action';

  constructor(public payload: { isInferiorBrowser: boolean; }) { }
}

export class UpdateSignalRConnectionStatusAction {
  static readonly type = '[Ui] Update SignalR Connection Status Action';

  constructor(public payload: { connected: boolean; }) { }
}

export class RegisterSignalRHandlersForUiAction {
  static readonly type = '[Ui] Register SignalR Handlers For UI Action';
}
